module.exports = __webpack_public_path__ + "static/1-41e7a04ac16511ab3453022ac6b09568.jpeg";